/**
 * Imported first by main.tsx, before any schema exists: zod never probes `new Function("")` for its JIT, which the
 * app's content security policy (no eval) blocks and reports as a violation on every page.
 */
import { z } from "zod";

z.config({ jitless: true });
